export default __webpack_public_path__ + "static/media/FactoryIconFinish.1b51d63d.svg";